import * as mapboxgl from 'mapbox-gl';

export function parseMarkerCssPx(value: string): number {
    const n = Number.parseFloat(value);
    return Number.isFinite(n) && n > 0 ? n : 24;
}

/** CSS transform scale for a pin placed at `zoomWhenPlaced` viewed at `currentZoom` (2× size per zoom level). */
export function pinZoomScaleFactor(
    baseWidthPx: number,
    zoomWhenPlaced: number,
    currentZoom: number,
    clamp: { minPx: number; maxPx: number },
): number {
    const rawPx = baseWidthPx * 2 ** (currentZoom - zoomWhenPlaced);
    const clampedPx = Math.min(clamp.maxPx, Math.max(clamp.minPx, rawPx));
    return clampedPx / baseWidthPx;
}

/** Map zoom at which a `scaleWithZoom` pin is drawn at its nominal width. */
export const PIN_REFERENCE_ZOOM = 15;

/**
 * Mapbox `icon-size` expression: `baseEm` at `refZoom`, multiplied by `growthPerZoom` per zoom level in
 * (divided per level out), clamped to [minEm, maxEm]. `growthPerZoom = 2` scales like map geometry.
 */
export function pinIconSizeMapboxExpression(
    baseEm: number,
    refZoom: number,
    minEm: number,
    maxEm: number,
    growthPerZoom = 2,
): mapboxgl.ExpressionSpecification {
    const logGrowth = Math.log(growthPerZoom);
    const zoomAtMin = refZoom + Math.log(minEm / baseEm) / logGrowth;
    const zoomAtMax = refZoom + Math.log(maxEm / baseEm) / logGrowth;
    return ['interpolate', ['exponential', growthPerZoom], ['zoom'], zoomAtMin, minEm, zoomAtMax, maxEm];
}
